import { useTypeHeaderIcon } from '../../../../utils/hooks/useTypeHeaderIcon';
import { useAuth } from '../../../../utils/Auth';
import styles from './RedirectLink.module.css';

const RedirectLink = ({reference}) => {
    const { qr_data, dataDispatch } = useAuth();

    const { header } = useTypeHeaderIcon(qr_data?.data?.qr_type);

    const handleRedirect = (e) => {
        const link = e.target.value;
        dataDispatch({type: 'redirect', data: link});
        dataDispatch({type: 'alt-redirect', data: link, index: 0 });
    };

    return (
        <div className={styles.container}>
            <div className={styles.inputGroup}>
                <input
                    type='url'
                    id='redirect_url-label'
                    className={styles.input}
                    onChange={handleRedirect}
                    value={qr_data.data.redirect_url}
                />
                <label htmlFor='redirect_url-label' className={styles.label}>{header} (URL)</label>
            </div>
        </div>
    );
};

export default RedirectLink;